export default __webpack_public_path__ + "static/media/ourMission3.5c5dbf6e.png";